import { Controller, useForm } from "react-hook-form";
import SyIcon from "../../../../shared/components/sy-icon";
import styleSheet from "./style.module.scss";
import OrbInput from "../../../../shared/forms/orb-input/orb-input";
import OrbTestArea from "../../../../shared/forms/orb-textarea";
import OrbButton from "../../../../shared/components/orb-button";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../services/orbit-service";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import { yupResolver } from "@hookform/resolvers/yup";
import { userInviteValidationSchema } from "../../../../shared/components/schema-validation/schema-validation";
import { getAuthDetails } from "../../../../feature/auth-slice";
import OrbMultiMail from "../../../../shared/forms/orb-multi-mail";
import { useState } from "react";
import { useParams } from "react-router";

const CitizenInvitePop = (props: any) => {
  const { onClose } = props;
  const [emailArray, setEmailArray] = useState<any>([]);
  const authSlice = useSelector(getAuthDetails);
    const { orbitId } = useParams();
  const defaultValues = {
    usr_email: "",
    email: "",
    usr_desc: "",
    orb_id: orbitId,
    cmp_id:authSlice.company_details.cmp_id
  };

  const {
    control,
    handleSubmit,
    setValue,
    setError,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues,
    resolver: yupResolver(userInviteValidationSchema),
  });

  const handleCloseClick = () => {
    onClose();
  };
  const onSubmit = (formValue: any) => {
    if (formValue.email) {
      formValue.usr_email.push({ email: formValue.email, valid: true });
    }
    delete formValue.email;
    inviteUserValidation(formValue);
  };

  const { mutate: inviteUser ,isPending:saveLoading} = useMutation({
    mutationFn: orbitService.inviteUser,
    onSuccess(data, variables, context) {
      onClose();
    },
  });

  const { mutate: inviteUserValidation ,isPending:validLoading} = useMutation({
    mutationFn: orbitService.inviteUserValidation,
    onSuccess(data, variables, context) {
      if (data.data.success) {
        variables.usr_email=variables.usr_email.map((val:any)=>val.email)
        inviteUser(variables);
      } else {
        setError("email", {
          type: "manual",
          message: data.data.message,
        });
        setValue("email", '');
        setValue("usr_email",  data.data.emails);
        setEmailArray(data.data.emails)
      }
    },
  });

  const onMailSelect = (mail: any) => {
    setValue("usr_email", mail);

  };

  return (
    <div className={`rounded-4  p-3 ${styleSheet.mainDiv}`}>
      <div className="d-flex align-items-center justify-content-between ">
        <p className="mohave m-0 font-25">lade weitere Bewohner ein</p>

        <SyIcon
          name="close"
          iconType="symbols"
          iconStyle="outlined"
          className={`${styleSheet.icon_colour} pointer`}
          onClick={handleCloseClick}
        />
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-3">
        <div className="">
          <Controller
            name={"email"}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <OrbMultiMail
                  placeholder={"E-Mail"}
                  value={value}
                  setError={setError}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  chipValue={emailArray}
                  type={"text"}
                  onChange={onChange}
                  label={"E-Mail"}
                  onMailSelect={onMailSelect}
                  errorMessage={errors.email?.message || ""}
                />
              );
            }}
          />
        </div>
        <div className="">
          <Controller
            name={"usr_desc"}
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <OrbTestArea
                  placeholder={
                    "Here is a pre-written text that people can change"
                  }
                  value={value}
                  onChange={onChange}
                  label={"Einladungstext"}
                  rows={7}
                  errorMessage={errors.usr_desc?.message || ""}
                />
              );
            }}
          />
        </div>
        <div className={`d-flex justify-content-end mt-1`}>
          <OrbButton
            type={"submit"}
            className={" mohave "}
            size={""}
            label={"Jetzt abfliegen!"}
            loading={validLoading||saveLoading}
          />
        </div>
      </form>
    </div>
  );
};

export default CitizenInvitePop;
